import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { IEDate, uGetDateFormat } from '@appbase/util';

import EventDetailHover from '@reserve/components/EventDetailHover.vue';

@Component({
    components: {
        EventDetailHover
    }
})
export default class EventItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.CalendarItem
    @Prop({ type: Date }) currentDate!: Date;

    height: number = 0;

    colorClass: any = {};        

    created() {        
        this.colorClass[this.item.color] = true;
        this.height = this.getDisplayHeight();
    }

    getDisplayHeight(): number {      
        if(this.item.isAllDayEvent) {
            return 48;
        } else {
            let startDate = IEDate(this.item.start);
            let endDate = IEDate(this.item.end);

            var timeinmills = endDate.getTime() - startDate.getTime(); 

            // startDate랑 endDate랑 다른 날짜일 때
            if (uGetDateFormat('yyyy-MM-DD', startDate) != uGetDateFormat('yyyy-MM-DD', endDate)) {
                if (uGetDateFormat('yyyy-MM-DD', this.currentDate) == uGetDateFormat('yyyy-MM-DD', startDate)) {
                    let targetDate = new Date(startDate);

                    targetDate.setDate(targetDate.getDate() + 1);
                    targetDate.setHours(0, 0, 0, 0);

                    let diffTime = targetDate.getTime() - startDate.getTime();
                    return diffTime / (1000 * 60 * 30);
                } else if (uGetDateFormat('yyyy-MM-DD', this.currentDate) == uGetDateFormat('yyyy-MM-DD', endDate)) {
                    let targetDate = new Date(endDate);
                    targetDate.setHours(0, 0, 0, 0);

                    let diffTime = endDate.getTime() - targetDate.getTime();
                    return diffTime / (1000 * 60 * 30);
                } else {
                    return 48;
                }
            } else {
                return timeinmills / (1000 * 60 * 30);
            }
        }        
    }

    onEventDblClick() {
        this.$emit('open', this.item);
    }
}